// material-ui
import {
    Box,
    Drawer,
} from '@mui/material';

// project imports

// import { useTranslation } from 'react-i18next';
import ChatMainPage from 'layout/MainLayout/Extension/ChatBot';

interface Props {
    open: boolean;
    handleDrawerOpen: () => void;
}

// ==============================|| KANBAN BACKLOGS - ADD ITEM ||============================== //

const Modal = ({ open, handleDrawerOpen }: Props) => {
    
    return (
        <Drawer
            sx={{
                ml: open ? 3 : 0,
                flexShrink: 0,
                zIndex: 1200,
                overflowX: 'hidden',
                width: { xs: 320, md: 450 },
                '& .MuiDrawer-paper': {
                    height: '100vh',
                    width: { xs: 320, md: 450 },
                    position: 'fixed',
                    border: 'none',
                    borderRadius: '0px'
                }
            }}
            variant="temporary"
            anchor="left"
            open={open}
            ModalProps={{ keepMounted: true }}
            onClose={handleDrawerOpen}
        >
            {open && (
                <Box>
                    <ChatMainPage />
                </Box>
            )}

        </Drawer>
    );
};
export default Modal;
